<template>
  <div class="table-wrap" :class="{ 'ocr-table-wrap--titled': title }">
    <div v-if="title" class="table-title-div">{{ title }}</div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "OcrTableWrap",
  props: {
    title: { type: String, default: "" },
  },
};
</script>
